module.exports = __webpack_public_path__ + "img/ico_info.30a06c83.svg";